import axios from 'axios';

const authorization = 'Basic YmFnYm5iOnN0b2Nh';
const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1dWlkIjoiMWJiM2U2MzItZjBjZC0xMWU5LTk5MDYtMDI0MmFjMTEwMDA4IiwiZW1haWwiOiJhbGVzc2FuZHJvK3NlaW5hK2Nlb0BiYWdibmIuY29tIiwiZXhwaXJlQXQiOnsiZGF0ZSI6IjIwMTktMTEtMTYgMjA6NTg6NTMuMDAwMDAwIiwidGltZXpvbmVfdHlwZSI6MSwidGltZXpvbmUiOiIrMDA6MDAifSwibmFtZSI6IkFsZXNzYW5kcm8gU2VpbmEiLCJjdXN0b21lcklkIjoiMjkifQ.t_UdxFCSn8IaJIvU-RW-6gP8RESIpYzUzKx1zv12KQA';


const baseInstance = axios.create({
    headers: {
        'Authorization': authorization,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        // 'Cookie': `;TOKEN=${token};`,
    }
});

export default baseInstance;

